import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html'
})
export class LayoutDefaultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
